import { useTranslation } from "react-i18next";

import Button from "src/components-v2/Button";
import Modal from "src/components-v2/Modal";

export type TermsConditionsBigFlipModalProps = {
  /**
   * Show or hide modal
   */
  showTerms: boolean;

  /**
   * Modal toggle
   */
  toggleTerms: Function;
};

function TermsConditionsBigFlipModal(props: TermsConditionsBigFlipModalProps) {
  const { showTerms, toggleTerms } = props;
  const { t } = useTranslation("verification");

  return (
    <Modal
      title={t("terms-condition.title")}
      show={showTerms}
      onClose={() => toggleTerms(false)}
      closeOnOverlay
      withoutCloseButton
      size="large"
    >
      <div className="u-text-semi">
        <div>
          <p>{t("terms-condition.general")}</p>
          <p>{t("terms-condition.guide")}</p>
        </div>
        <p className="u-font-bold">{t("terms-condition.responsibility")}</p>
        <ol className="u-pl-3">
          <li className="u-mb-2">{t("terms-condition.point-1")}</li>
          <li>{t("terms-condition.point-2")}</li>
        </ol>
        <p className="u-font-bold">{t("terms-condition.policy")}</p>
        <ol className="u-pl-3">
          <li className="u-mb-2">
            {t("terms-condition.point-1-1")}
            <b>{t("terms-condition.point-1-bold-1")}</b>
            {t("terms-condition.point-1-2")}
            <b>{t("terms-condition.point-1-bold-2")}</b>
          </li>
          <li className="u-mb-2">{t("terms-condition.point-2-1")}</li>
          <li className="u-mb-2">{t("terms-condition.point-3")}</li>
          <li className="u-mb-2">{t("terms-condition.point-4")}</li>
          <li className="u-mb-2">
            {t("terms-condition.point-5-1")}
            <b>{t("terms-condition.point-5-bold-1")}</b>
            {t("terms-condition.point-5-2")}
          </li>
          <li className="u-mb-2">{t("terms-condition.point-6")}</li>
          <li className="u-mb-2">{t("terms-condition.point-7")}</li>
          <li className="u-mb-2">{t("terms-condition.point-8")}</li>
          <li className="u-mb-2">{t("terms-condition.point-9")}</li>
        </ol>

        <p className="u-text-justify u-font-bold u-my-6">{t("terms-condition.desc")}</p>
      </div>

      <Button onClick={() => toggleTerms(false)} block>
        {t("terms-condition.agree")}
      </Button>
    </Modal>
  );
}

export default TermsConditionsBigFlipModal;
